// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  text-align: right;
}

.pagination-button {
  background-color: var(--blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  margin: 3px;
  cursor: pointer;
}

.pagination-numbers button {
  background-color: var(--blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  margin: 3px;
  cursor: pointer;
}

.pagination-numbers button.active {
  background-color: var(--light-blue);
  color: var(--blue);
  font-weight: bold;
}

.pagination-button:hover {
  background-color: #024893;
}

.pagination-button:disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
}

.dropdown {
  border: 1px solid rgb(223, 223, 223);
  border-radius: 5px;
  padding: 10px;
  height: auto;
  width: auto;
  min-width: 300px;
  overflow: hidden;
  transition: 0.2s all;
  box-shadow: none;
}

.table {
  height: auto;
  width: 100%;
}

.table-responsive .title,
.table-responsive .sub-title {
  padding: 5px;
  border-right: 1px solid #ddd;
}

.table-responsive .nome,
.table-responsive .local,
.table-responsive .data,
.table-responsive .dias,
.table-responsive .vendidos,
.table-responsive .receita,
.table-responsive .cortesias,
.table-responsive .taxa {
  padding: 5px;
}

.table-responsive .data,
.table-responsive .vendidos,
.table-responsive .receita,
.table-responsive .cortesias,
.table-responsive .taxa {
  border-right: 1px solid #ddd
}

.table-responsive .data{
  border-left: 1px solid #ddd
}

.table-responsive .taxa {
  border-right: none;
}

.table-responsive {
  overflow-x: auto;
  border: 1px solid #ddd;
}


.table-responsive .title {
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  color: var(--blue);
  padding: 5px;
}

.table-responsive .sub-title {
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  padding: 5px;
}

.table-responsive .nome {
  color: var(--blue);
  font-weight: bold;
  vertical-align: middle;
  text-transform: uppercase;
  cursor: pointer;
}

.table-responsive .local {
  color: gray;
  vertical-align: middle;
  text-transform: capitalize;
  cursor: pointer;
}

.table-responsive .data {
  color: gray;
  vertical-align: middle;
  cursor: pointer;
}

.table-responsive .dias {
  color: var(--blue);
  vertical-align: middle;
  cursor: pointer;
}

.table-responsive .vendidos {
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.table-responsive .receita {
  color: rgb(2, 161, 2);
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.table-responsive .cortesias {
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.table-responsive .taxa {
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.mobile-table {
  display: none;
}

@media all and (max-width: 600px) {
  .table-responsive {
    display: none;
  }

  .mobile-table {
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .mobile-table th,
  .mobile-table td {
    border: 1px solid #ccc;
    padding: 6px;
    text-align: center;
  }

  .mobile-table tbody td {
    cursor: pointer;
    overflow: hidden;
  }

  .mobile-table tbody tr {
    margin-bottom: 10px;
  }

  .mobile-table .event-odd {
    background-color: #ffffff;
  }

  .mobile-table .event-even {
    background-color: #f2f2f2;
  }

  .title {
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    color: var(--blue);
  }

  .sub-title {
    text-align: center;
    vertical-align: middle;
  }

  .nome {
    color: var(--blue);
    font-weight: bold;
    vertical-align: middle;
    text-transform: uppercase;
    text-align: center;
  }

  .local {
    color: gray;
    vertical-align: middle;
    text-transform: capitalize;
    text-align: center;
  }

  .data {
    color: gray;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
  }

  .dias {
    color: var(--blue);
    vertical-align: middle;
    text-align: center;
  }

  .vendidos {
    text-align: center;
    vertical-align: middle;
  }

  .receita {
    color: rgb(2, 161, 2);
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
  }

  .cortesias {
    text-align: center;
    vertical-align: middle;
  }

  .taxa {
    text-align: center;
    vertical-align: middle;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Tables/Event/tableStyle.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;EAKE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":[".pagination-container {\n  text-align: right;\n}\n\n.pagination-button {\n  background-color: var(--blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  margin: 3px;\n  cursor: pointer;\n}\n\n.pagination-numbers button {\n  background-color: var(--blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  margin: 3px;\n  cursor: pointer;\n}\n\n.pagination-numbers button.active {\n  background-color: var(--light-blue);\n  color: var(--blue);\n  font-weight: bold;\n}\n\n.pagination-button:hover {\n  background-color: #024893;\n}\n\n.pagination-button:disabled {\n  background-color: #ccc;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.dropdown {\n  border: 1px solid rgb(223, 223, 223);\n  border-radius: 5px;\n  padding: 10px;\n  height: auto;\n  width: auto;\n  min-width: 300px;\n  overflow: hidden;\n  transition: 0.2s all;\n  box-shadow: none;\n}\n\n.table {\n  height: auto;\n  width: 100%;\n}\n\n.table-responsive .title,\n.table-responsive .sub-title {\n  padding: 5px;\n  border-right: 1px solid #ddd;\n}\n\n.table-responsive .nome,\n.table-responsive .local,\n.table-responsive .data,\n.table-responsive .dias,\n.table-responsive .vendidos,\n.table-responsive .receita,\n.table-responsive .cortesias,\n.table-responsive .taxa {\n  padding: 5px;\n}\n\n.table-responsive .data,\n.table-responsive .vendidos,\n.table-responsive .receita,\n.table-responsive .cortesias,\n.table-responsive .taxa {\n  border-right: 1px solid #ddd\n}\n\n.table-responsive .data{\n  border-left: 1px solid #ddd\n}\n\n.table-responsive .taxa {\n  border-right: none;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  border: 1px solid #ddd;\n}\n\n\n.table-responsive .title {\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--blue);\n  padding: 5px;\n}\n\n.table-responsive .sub-title {\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n  padding: 5px;\n}\n\n.table-responsive .nome {\n  color: var(--blue);\n  font-weight: bold;\n  vertical-align: middle;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.table-responsive .local {\n  color: gray;\n  vertical-align: middle;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n\n.table-responsive .data {\n  color: gray;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-responsive .dias {\n  color: var(--blue);\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-responsive .vendidos {\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-responsive .receita {\n  color: rgb(2, 161, 2);\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-responsive .cortesias {\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.table-responsive .taxa {\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.mobile-table {\n  display: none;\n}\n\n@media all and (max-width: 600px) {\n  .table-responsive {\n    display: none;\n  }\n\n  .mobile-table {\n    display: block;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .mobile-table th,\n  .mobile-table td {\n    border: 1px solid #ccc;\n    padding: 6px;\n    text-align: center;\n  }\n\n  .mobile-table tbody td {\n    cursor: pointer;\n    overflow: hidden;\n  }\n\n  .mobile-table tbody tr {\n    margin-bottom: 10px;\n  }\n\n  .mobile-table .event-odd {\n    background-color: #ffffff;\n  }\n\n  .mobile-table .event-even {\n    background-color: #f2f2f2;\n  }\n\n  .title {\n    font-weight: bold;\n    text-align: center;\n    vertical-align: middle;\n    color: var(--blue);\n  }\n\n  .sub-title {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .nome {\n    color: var(--blue);\n    font-weight: bold;\n    vertical-align: middle;\n    text-transform: uppercase;\n    text-align: center;\n  }\n\n  .local {\n    color: gray;\n    vertical-align: middle;\n    text-transform: capitalize;\n    text-align: center;\n  }\n\n  .data {\n    color: gray;\n    font-weight: bold;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .dias {\n    color: var(--blue);\n    vertical-align: middle;\n    text-align: center;\n  }\n\n  .vendidos {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .receita {\n    color: rgb(2, 161, 2);\n    font-weight: bold;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .cortesias {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .taxa {\n    text-align: center;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
